export default __webpack_public_path__ + "static/media/roboto-v27-latin-regular.9b78ea3b.woff";